module.exports = "/packs/012-2a470b16ee0aadd7ebe0cdebbbdf9f4f.jpg";